import { useEffect, useState } from "react";
import { ShieldAlert, Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const REASON_TEXT = {
  risk_review: "A payout is on hold pending a security review of your account.",
  verification_failed: "Your settlement bank account could not be verified.",
  requires_update: "Your settlement bank details need to be updated.",
  suspended: "Your settlement account is suspended pending verification.",
  return_window: "A settlement is briefly held while orders complete their return window.",
  on_hold: "A settlement payout is currently on hold.",
};

export const PayoutHoldBanner = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/marketplace/seller/payout-status").then((r) => setSt(r.data)).catch(() => setSt(null));
  useEffect(() => { load(); }, []);

  if (!st || !st.hold) return null;

  const reverify = async () => {
    setBusy(true);
    try {
      const r = await api.post("/marketplace/seller/payout/reverify");
      toast.success(r.data?.message || "Verification request sent.");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send request. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const msg = REASON_TEXT[st.reason] || "A payout is currently on hold.";

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-300 bg-amber-50 p-4" data-testid="payout-hold-banner">
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
        <div>
          <p className="text-sm font-semibold text-amber-900">Verification needed — payout on hold</p>
          <p className="text-sm text-amber-800">{msg} Your bank details are safe and never shown here.
            {st.held_amount > 0 && <span className="font-medium"> ₹{st.held_amount.toLocaleString("en-IN")} held.</span>}
          </p>
        </div>
      </div>
      {st.reverify_requested ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-4 py-2 text-sm font-semibold text-emerald-700" data-testid="reverify-requested">
          <CheckCircle2 className="h-4 w-4" /> Verification requested
        </span>
      ) : (
        <button onClick={reverify} disabled={busy} data-testid="reverify-payout-btn"
          className="inline-flex items-center gap-1.5 rounded-full brand-gradient-bg px-4 py-2 text-sm font-semibold text-white disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldAlert className="h-4 w-4" />} Re-verify now
        </button>
      )}
    </div>
  );
};
